<template>
  <div>
    <van-nav-bar
      :title="$route.query.title"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />

    <van-row type="flex" justify="center" style="margin-top: 50px">
      <van-col span="6"></van-col>
      <van-col span="6">
        <img style="width: 100px;margin: 10px 0 10px 0" src="http://cdn.sport.hhstu.xyz/%E6%88%90%E5%8A%9F.png" alt="">
        <h2>预约成功</h2>

      </van-col>
      <van-col span="6"></van-col>
    </van-row>
    <p style="text-align:center;margin-top: 10px">预约记录点击 “我的->当前俱乐部->预约详情”即可查看</p>
    <div style="margin: 100px 0 100px 0"></div>
    <van-row type="flex" justify="center" style="margin-top: 50px">
      <van-col span="0"></van-col>
      <van-col span="28" @click="imgShow">
        <!--    <a href="http://m.zhan.com/zt/ieltsrumen86457.html">-->
        <!--        <img src="http://cdn.sport.hhstu.xyz/eleme.png" style="width: 100%" alt="">-->
        <img src="http://cdn.sport.hhstu.xyz/societies_lb1.png" style="width: 100%" alt="">
        <!--    </a>-->

      </van-col>
      <van-col span="0"></van-col>
    </van-row>

  </div>
</template>

<script>
import Vue from 'vue';
import {
  NavBar,
  Col,
  Row,
  Icon,
  ImagePreview
} from 'vant';

Vue.use(NavBar);
Vue.use(Col);
Vue.use(Row);
Vue.use(Icon);
Vue.use(ImagePreview);
export default {
  name: "VenueBookingSuccess",
  methods: {
    onClickLeft() {
      this.$router.replace("/VenueBooking");
    },
    imgShow() {
      ImagePreview({
        images: [
          'http://cdn.sport.hhstu.xyz/societies_lb1.png',
        ],
        closeable: true,
      });
    }
  }
}
</script>

<style scoped>

</style>
